// extracted by mini-css-extract-plugin
module.exports = {"homecont":"addmovies_homecont__3o0vj","coldiv":"addmovies_coldiv__2NaAi","col2":"addmovies_col2__B-rZq","cont":"addmovies_cont__2XMja"};